/**
 * Normalize shipping country codes to ISO 3166-1 alpha-2 for Gelato + pricing.
 * Mirrors server/countryCodes.js — keep aliases in sync.
 */

const ALIASES = {
  UK: 'GB',
  'UNITED KINGDOM': 'GB',
  'GREAT BRITAIN': 'GB',
  BRITAIN: 'GB',
  ENGLAND: 'GB',
  SCOTLAND: 'GB',
  WALES: 'GB',
  USA: 'US',
  'UNITED STATES': 'US',
  'UNITED STATES OF AMERICA': 'US',
  AMERICA: 'US',
  UAE: 'AE',
  'UNITED ARAB EMIRATES': 'AE',
  KOREA: 'KR',
  'SOUTH KOREA': 'KR',
  'REPUBLIC OF KOREA': 'KR',
  'NORTH KOREA': 'KP',
  RUSSIA: 'RU',
  'RUSSIAN FEDERATION': 'RU',
  VIETNAM: 'VN',
  'VIET NAM': 'VN',
  TAIWAN: 'TW',
  HOLLAND: 'NL',
  NETHERLANDS: 'NL',
  CZECHIA: 'CZ',
  'CZECH REPUBLIC': 'CZ'
}

const ALPHA3 = {
  USA: 'US',
  GBR: 'GB',
  CAN: 'CA',
  AUS: 'AU',
  DEU: 'DE',
  FRA: 'FR',
  ESP: 'ES',
  ITA: 'IT',
  MEX: 'MX',
  JPN: 'JP',
  CHN: 'CN',
  IND: 'IN'
}

/**
 * @param {string} raw
 * @param {string} [fallback='US']
 * @returns {string} uppercase ISO alpha-2 (or fallback)
 */
export function normalizeCountryCode(raw, fallback = 'US') {
  const trimmed = String(raw || '').trim()
  if (!trimmed) return fallback

  const upper = trimmed.toUpperCase()
  if (ALIASES[upper]) return ALIASES[upper]

  if (/^[A-Z]{2}$/.test(upper)) return upper

  if (ALPHA3[upper]) return ALPHA3[upper]

  if (upper.length >= 2 && upper.length <= 3) return upper.slice(0, 2)
  return fallback
}
